import { MapStyles } from "../../constants/mapStyles"

import {
    computeBrushParametrics,
    computeBrushRadiusAtMousePosition,
    createParametrics,
    initStateFromFeatures,
    initStateFromStartingFeatures,
} from "../utils/lateralizedUtils"
import { computeLateralizedFeatures } from "../utils/layerUtils"


export let LateralizedRubberMode = {}

LateralizedRubberMode.updateCursor = function () {
    const style = this.map.getStyle()
    const cursorFile = style.name === MapStyles.plan.name ? "circle_cursor_dark.png" : "circle_cursor_light.png"

    this.map.getCanvas().style.cursor = `url(assets/resources/${cursorFile}) 32 32, pointer`
}

LateralizedRubberMode.onSetup = function (opts) {
    var state = {}

    state.options = opts

    if (!state.options?.roadSegments?.features.length) {
        state.roadSegments = []
        return state
    }

    state.roadSegments = computeLateralizedFeatures(state.options.roadSegments, this.map)
    state.startingFeatures = state.options.startingFeatures

    this.map.on("zoom", () => {
        state.roadSegments = computeLateralizedFeatures(state.options.roadSegments, this.map)
        this._ctx.store.isDirty = true
        this._ctx.store.render()
    })
    this.map["dragPan"].disable()

    state.updateCursorFunction = this.updateCursor.bind(this)
    this.map.on("style.load", state.updateCursorFunction)
    this.updateCursor()

    const currentFeatures = opts.drawFeatures || []

    if (currentFeatures.length || opts.hasBeenUpdated) {
        state.parametricSegments = []
        state.featureIds = []

        initStateFromFeatures(state, currentFeatures)
    } else {
        const defaultParametrics = initStateFromStartingFeatures(state)
        createParametrics(this, state, defaultParametrics, true, state.options.existingFeatures)
    }

    return state
}

LateralizedRubberMode.onStop = function (state) {
    this.map.off("style.load", state.updateCursorFunction)
}

LateralizedRubberMode.onDrag = function (state, e) {
    if (this.map && state.roadSegments) {
        const brushRadius = computeBrushRadiusAtMousePosition(this, e)

        const paintedParametrics = computeBrushParametrics(state, brushRadius, e, state.options?.brush?.properties)

        if (paintedParametrics.length) {
            const featuresUpdated = createParametrics(this, state, paintedParametrics, false, state.options.existingFeatures)

            if (featuresUpdated) {
                this.map.fire("draw.paint_updated")
            }
        }
    }
}

LateralizedRubberMode.onMouseDown = function (state, e) {
    this.onDrag(state, e)
}

LateralizedRubberMode.toDisplayFeatures = function (state, geojson, display) {
    const original = this.getFeature(geojson.properties.id)
    const featureCollection = {
        type: "FeatureCollection",
        features: [{
            ...geojson,
            properties: {
                ...original?.properties,
                ...geojson.properties,
            },
        }],
    }
    const lateralizedFeatureCollection = computeLateralizedFeatures(featureCollection, this.map)
    const feature = lateralizedFeatureCollection.features[0]
    display(feature)
}

LateralizedRubberMode.onTrash = function (state) {
    const defaultParametrics = initStateFromStartingFeatures(state)
    createParametrics(this, state, defaultParametrics, true, state.options.existingFeatures)
}